import moment from 'moment';
import { memo } from 'react';
import { Link } from 'react-router-dom';
// import Downloader from '../../../../../../../components/ui/Downloader';

const CRMLeadCommentMessage = ({
  data = {},
  sameToNext,
  setOpen,
  setImages,
}) => {
  const link = extractUrlFromText(data?.message);
  const isImage = isImageUrl(link?.url);

  const onClickImage = () => {
    setImages({
      imgs: [link?.url, link?.url],
      titles: ['Telegram bot image', 'Telegram bot image'],
      captions: ['Bot image', 'Bot image'],
    });
    setOpen(true);
  };

  return (
    <div
      className='flex gap-2'
      style={{
        marginBottom: sameToNext ? '2px' : '4px',
        justifyContent: data?.is_client == 1 ? 'left' : 'right',
        flexDirection: data?.is_client == 1 ? '' : 'row-reverse',
      }}
    >
      {sameToNext ? (
        <div className='lead-comment-icon text-base leading-4 w-[42px] h-[42px] min-w-[42px] min-h-[42px] flex items-center justify-center' />
      ) : (
        <div className='lead-comment-icon self-end text-base leading-4 border-2 border-base-color text-base-color rounded-full w-[42px] h-[42px] min-w-[42px] min-h-[42px] flex items-center justify-center'>
          <i className='bi bi-person text-xl'></i>
        </div>
      )}

      <div
        className={`lead-comment-wrapper flex items-center p-4 pb-5 max-w-[75%] min-w-44 rounded-xl w-fit relative`}
        style={{
          background: data?.is_client == 1 ? '#405368' : '#57b2e0',
        }}
      >
        {!sameToNext &&
          (data?.is_client == 1 ? (
            <div className='rounded-r-xl w-4 absolute -left-2 bottom-0 h-[20px] bg-[#405368]'>
              <div className='h-full w-2 rounded-br-[100px] bg-[#F2F3F7] z-10'></div>
            </div>
          ) : (
            <div className='rounded-l-xl min-w-4 w-4 absolute -right-2 bottom-0 h-[20px] bg-[#57b2e0]'>
              <div className='h-full min-w-2 w-2 ml-2 rounded-bl-[100px] bg-[#F2F3F7] z-10'></div>
            </div>
          ))}
        <div className='lead-comment-details w-full text-white'>
          {isImage ? (
            <div className='relative h-auto max-w-36'>
              {/* <div className='absolute top-2 left-2 w-32'>
                <Downloader url={link?.url} label={link?.label} />
              </div> */}
              <img
                className='w-full h-full object-cover cursor-pointer'
                src={link?.url}
                onClick={onClickImage}
                alt='message-image'
              />
            </div>
          ) : link?.isUrl ? (
            <div className='overflow-hidden text-ellipsis h-fit'>
              {/* <div className='w-fit max-w-full'>
                <Downloader url={link?.url} label={link?.label} />
              </div> */}
              <Link to={link?.url} className='no-underline' target='_blank'>
                <span className='cursor-pointer text-blue-500'>
                  {link?.url}
                </span>
                <br />
                <span className='cursor-pointer text-blue-500'>
                  {link?.label}
                </span>
              </Link>
            </div>
          ) : (
            <div>{data?.message}</div>
          )}
          <div
            className='text-[12px] absolute bottom-0.5 right-2'
            style={{
              color: data?.is_client == 1 ? '#d1d5db' : '#2e3641',
            }}
          >
            {moment(data?.created_at).format('DD.MM.YYYY HH:mm')}
          </div>
        </div>
      </div>
    </div>
  );
};
export default memo(CRMLeadCommentMessage);

// utils/isImageUrl.js
const IMAGE_EXTENSIONS = [
  'jpg',
  'jpeg',
  'png',
  'gif',
  'webp',
  'svg',
  'bmp',
  'ico',
  'avif',
];

const isImageUrl = (url) => {
  if (!url || typeof url !== 'string') return false;

  try {
    const { pathname } = new URL(url);
    const extension = pathname.split('.').pop().toLowerCase();

    // Agar extension bo'lmasa yoki uzunligi 1-4 belgidan oshsa, ehtiyot bo'lamiz
    if (!extension || extension.length > 4) return false;

    return IMAGE_EXTENSIONS.includes(extension);
  } catch (e) {
    // Noto'g'ri URL bo'lsa
    return false;
  }
};

export const extractUrlFromText = (text) => {
  if (!text || typeof text !== 'string')
    return { url: null, label: text, isUrl: false };

  const match = text.match(/\[([^\]]+)\]\s*(https?:\/\/[^\s]+)/i);
  if (!match) return null;

  const tag = match[1].trim(); // "photo"
  let url = match[2].trim();
  console.log(tag, url);
  if (match) {
    return { url, tag, isUrl: true };
  }

  return { url: null, label: text, isUrl: false };
};
